import React from "react";
import "../Pages/styles/Footer.css";
import { Link } from "react-router-dom";

import logo from "../Components/Navigation logo/suryanirbhar_icon.png";


const Footer = () => {

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-left">
          <h3>Connect with us</h3>

          <div className="social-icons">

            {/* FACEBOOK */}
            <a
              href="https://www.facebook.com/suryanirbhar.agritech/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>

            {/* INSTAGRAM */}
            <a
              href="https://www.instagram.com/suryanirbhar_agritech_/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>

            {/* YOUTUBE */}
            <a
              href="https://youtube.com/@suryanirbhar_agritech?si=uNhjJx-LTAuU1Ows"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>

            {/* LINKEDIN (placeholder — replace later) */}
            <a href="https://www.linkedin.com/company/suryanirbhar-agritech/">
              <i className="fab fa-linkedin-in"></i>
            </a>

           <a href="https://wa.me/919380226919?text=Hello%20I%20want%20to%20know%20about%20your%20products"
            target="_blank"
             rel="noreferrer">
             <i className="fab fa-whatsapp"></i>
            </a>

          </div>
        </div>

        {/* CENTER LOGO */}
        <div className="footer-center">
          <Link to="/" onClick={handleLogoClick}>
            <img src={logo} alt="logo" className="footer-logo" />
          </Link>
        </div>

        {/* RIGHT */}
        <div className="footer-right">
          <p className="footer-links">
          
          <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
          Contact Us
         </Link>{" "}
        | <span>Privacy Policy</span> | <span>Sitemap</span>
          </p>
          <p className="footer-links">
            Copyright © 2026 Surya Agro Tech
          </p>
          <p className="footer-links">All Rights Reserved</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;